import {
    CountryAndPlaceSearchItem,
    CountryAndPlaceSearchPageType,
} from '../domain/types/countryAndPlaceSearch';

export type CountryAndPlaceSearchResultFromPyrite = {
    id: string;
    name: string;
    url: string;
    slug: string;
    pageType: CountryAndPlaceSearchPageType;
};

export function normalizeCountryAndPlaceSearchResultFromPyrite(
    countryAndPlaceSearchResult: CountryAndPlaceSearchResultFromPyrite,
): CountryAndPlaceSearchItem {
    return {
        id: countryAndPlaceSearchResult.id,
        name: countryAndPlaceSearchResult.name,
        url: countryAndPlaceSearchResult.url,
        slug: countryAndPlaceSearchResult.slug,
        pageType: countryAndPlaceSearchResult.pageType,
    };
}
